// @flow
import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";
import { Element, scroller } from "react-scroll";
import { WarningIcon } from "@material-ui/icons/Warning";
import { create, reset } from "../../../core/form/actions";
import styles from "../styles/styles";
import FirstPage from "./FirstPage";
import SecondPage from "./SecondPage";
import ThirdPage from "./ThirdPage";

type Props = {
    error: string,
    loading: boolean,
    created: Object,
    create: Function,
    dataLoading: boolean,
    dataError: Object,
    classes: Object,
};

export const Create = ({
    loading,
    error,
    create,
    created,
    dataLoading,
    dataError,
    classes,
}: Props) => {
    const [page, setPage] = useState(1);
    let Page = null;

    useEffect(() => {
        // Somewhere else, even another file
        scroller.scrollTo(`form_page_${page}`, {
            duration: 200,
            delay: 100,
            smooth: true,
            offset: -150,
        });
    }, [page]);

    switch (page) {
        case 1:
            Page = (
                <Element name="form_page_1">
                    <FirstPage onSubmit={() => setPage(page + 1)} />
                </Element>
            );
            break;
        case 2:
            Page = (
                <Element name="form_page_2">
                    <SecondPage
                        onSubmit={() => setPage(page + 1)}
                        previousPage={() => setPage(page - 1)}
                    />
                </Element>
            );
            break;
        case 3:
            Page = (
                <Element name="form_page_3">
                    <ThirdPage
                        onSubmit={create}
                        previousPage={() => setPage(page - 1)}
                    />
                </Element>
            );
            break;
        default:
            Page = <></>;
    }

    return (
        <div className="et_pb_row">
            {created && (
                <Typography variant="subtitle1" className={classes.success}>
                    {created}
                </Typography>
            )}

            {dataLoading && <CircularProgress />}

            {dataError && (
                <div>
                    <WarningIcon />
                    <span>Impossible de charger les données du formulaire</span>
                </div>
            )}

            {loading && <p>Chargement...</p>}
            {error && <p>{error}</p>}

            {!created && !dataLoading && !dataError && Page}
        </div>
    );
};

const mapStateToProps = state => ({
    created: state.formCustom.created,
    error: state.formCustom.error,
    loading: state.formCustom.loading,
    location: state.location,
    dataLoading: state.types.loading,
    dataError: state.types.error,
});

const mapDispatchToProps = dispatch => ({
    create: values =>
        new Promise((resolve, reject) => {
            dispatch(create({ values, resolve, reject }));
        }),
    reset,
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(Create);
